export default __webpack_public_path__ + "static/media/Magic.0bdaa6aa.png";